import { object, number } from 'yup'
import { MultiStepSchema } from 'components/Wizards/schemas/Types'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { project } from 'components/Wizards/schemas/shared/project'
import { topic } from 'components/Wizards/schemas/shared/topic'
import { tone } from 'components/Wizards/schemas/shared/voiceTones'
import { language } from 'components/Wizards/schemas/shared/language'
import { brandKitId } from 'components/Wizards/schemas/shared/brandKitId'
import { count } from 'components/Wizards/schemas/shared/count'
import { crossPostAccounts } from 'components/Wizards/schemas/shared/crossPostAccounts'
import { safify } from 'components/Wizards/schemas/utils/safify'
import { meta } from '../schemaCommon'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { includeEmojis } from 'components/Wizards/schemas/shared/includeEmojis'

export const FlowDSchema = ({ generationType }: { generationType: string }) => {
  const RefineThreadDetails = object({
    topic: topic
      .meta({
        label: `What is your thread about?`,
        generate: false,
        generationType,
      })
      .required(),
    brand_kit_id: brandKitId,
    tone: tone.optional().meta({ generationType }),
    filename,
    project,
    language,
    include_emojis: includeEmojis.meta({ overflow: true }),
    count: count.default(5).min(1).max(6).meta({
      label: 'How many posts in the thread?',
    }),
    cross_post_accounts: crossPostAccounts,
  }).meta({
    title: 'Refine thread details',
  })

  const PickImage = object({
    initial_media_file_id: number().default(undefined).transform(safify),
  }).meta({
    title: 'Pick an image',
    supportedMediaTypes: ['image'],
    showMediaLibrary: true,
    submitLabel: 'Create Thread',
  })

  return {
    meta,
    steps: [RefineThreadDetails, PickImage],
  } as MultiStepSchema<ChannelType>
}
